<template>
  <!-- FORM -->
  <v-card v-if="vCardForm" class="colorDominant">
    <!-- TOOLBAR -->
    <v-toolbar
      v-if="!playerFromAgent"
      height="64"
      class="elevation-0 colorDominant flex-grow-0"
    >
      <v-toolbar-title>{{ $t("register") }}</v-toolbar-title>
      <div class="flex-grow-1"></div>
      <Login :urlRedirect="urlRedirect" />
      <v-btn class="ml-2" icon @click="closeDialog()" v-if="!hideCloseDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-divider></v-divider>

    <v-card-text
      class="pb-5 px-0 pl-5 pt-5"
      :style="{ height: $vuetify.breakpoint.smAndDonw ? '300px' : '' }"
    >
      <!-- ALERT *** Affiliate BY *** -->
      <template v-if="playerFromAgent && nameAgent">
        <v-alert
          border="left"
          colored-border
          color="accent"
          class="mr-4 mb-0"
          dense
          text
          type="success"
          :icon="false"
        >
          <v-progress-circular
            :size="18"
            v-if="affiliate_progress"
            indeterminate
          ></v-progress-circular>
          <div v-if="!affiliate_progress">
            <span class="grey--text">{{ $t("indicatedBy") }}</span>
            <strong>&nbsp; {{ nameAgent }}</strong>
          </div>
        </v-alert>
      </template>

      <v-form
        ref="form"
        v-model="valid1"
        class="pt-3"
        lazy-validation
        autocomplete="off"
      >
        <v-subheader class="mx-0 px-0 mb-4 font-weight-bold text-uppercase"
          >{{ $t("formRegisterTitlePersonalData") }}
          <v-divider class="ml-4"></v-divider>
        </v-subheader>

        <div style="margin: 0 auto; max-width: 400px" class="pr-4">
          <!-- NOME E SOBRENOME -->
          <v-text-field
            v-model="name"
            :rules="[rules.required, rules.nameValid, rules.max]"
            :label="$t('nameAndLastName')"
            clearable
            required
            name="newName"
            prepend-icon="mdi-account-circle"
            tabindex="101"
            type="text"
            outlined
            autofocus
            @change="startRegistrationGA4(name)"
          ></v-text-field>

          <!-- TELEFONE -->
          <v-text-field
            v-model="phone"
            :rules="[rules.required, phoneRule]"
            v-mask="maskPhone"
            :label="$t('phone')"
            :placeholder="placeholderPhone"
            required
            clearable
            outlined
            type="tel"
            prepend-icon="mdi-phone"
            tabindex="102"
            v-on="$isCreditOnline() ? { change: validatePhone } : {}"
            :loading="validatePhoneLoading"
            :error="phoneError"
            :error-messages="phoneErrorMessage"
          ></v-text-field>

          <!-- DOCUMENTO CPF (APENAS BRASIL, PARA CREDITO ONLINE!) -->
          <v-text-field
            v-model="cpf"
            label="Documento (CPF)"
            :rules="[rules.required, rules.docCPF, rules.validateCPF]"
            v-mask="'###.###.###-##'"
            outlined
            required
            clearable
            :loading="loadingDoc"
            tabindex="103"
            type="tel"
            :error="errorActive"
            :error-messages="errorMessage"
            prepend-icon="mdi-file-document"
            v-if="$isCreditOnline()"
            @change="checkCPF(cpf)"
          ></v-text-field>

          <!-- DATA DE NASCIMENTO (APENAS PARA CRÉDITO ONLINE) -->
          <template v-if="$isCreditOnline()">
            <v-text-field
              v-model="birthdate"
              prepend-icon="mdi-calendar"
              :rules="[rules.required, rules.birthdate]"
              :label="$t('dateOfBirth')"
              placeholder="DD-MM-AAAA"
              required
              clearable
              tabindex="104"
              type="tel"
              outlined
              v-mask="'##-##-####'"
            ></v-text-field>
          </template>
          <!-- <template>
            <v-menu
              v-if="$isCreditOnline()"
              ref="menu"
              v-model="menuBirthdate"
              :rules="[rules.required, rules.birthdate]"
              tabindex="104"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="computedDateFormatted"
                  :rules="[rules.required, rules.birthdate]"
                  :label="$t('dateOfBirth')"
                  v-on="on"
                  outlined
                  required
                  prepend-icon="mdi-calendar"
                  tabindex="105"                  
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="date"
                :rules="[rules.required, rules.birthdate]"
                :max="new Date().toISOString().substr(0, 10)"
                min="1940-01-01"
                @change="save"
              ></v-date-picker>
            </v-menu>
          </template> -->

          <!-- E-MAIL -->
          <v-text-field
            v-model="email"
            :rules="[rules.invalid, maybeRequired, rules.validateEmailDomain]"
            :label="labelEmail"
            clearable
            outlined
            type="email"
            prepend-icon="mdi-email"
            :error-messages="errorMessageEmail"
            :error="errorActiveEmail"
            name="newEmail"
            tabindex="105"
            :disabled="$isCreditOnline() && !cpfValidated"
            @change="validateEmail()"
            autocapitalize="off"
          ></v-text-field>
        </div>

        <v-subheader
          class="mx-0 px-0 mb-4 font-weight-bold text-uppercase"
          v-if="$isCreditOnline()"
        >
          {{ $t("promotionalCodes") }}
          <v-divider class="ml-4"></v-divider>
        </v-subheader>

        <div style="margin: 0 auto; max-width: 400px" class="pr-4">
          <!-- Código de afiliação -->
          <!-- <v-text-field
            v-if="
              $isCreditOnline() &&
                !playerFromAgent &&
                $permissions().showAffiliateCode
            "
            v-model="affiliateCode"
            :rules="[rules.noSpacesAreAllowed]"
            :label="$t('affiliateCode')"
            clearable
            outlined
            type="text"
            prepend-icon="mdi-account-multiple-plus"
            tabindex="105"
            autocapitalize="off"
            :error-messages="affiliateCodeErrorMessage"
            :error="affiliateCodeError"
            :counter="50"
            maxlength="50"
          ></v-text-field> -->
          <!-- Código de afiliação -->
          <v-text-field
            v-if="$isCreditOnline()"
            v-model="promoCode.value"
            :loading="promoCode.loading"
            :error-messages="promoCode.error.message"
            :error="promoCode.error.status"
            :success="promoCode.success.message != ''"
            :success-messages="promoCode.success.message"
            @keyup="onKeyUp"
            :label="$t('promoCode')"
            clearable
            outlined
            type="text"
            prepend-icon="mdi-gift-outline"
            tabindex="105"
            autocapitalize="off"
            :counter="20"
            maxlength="20"
          ></v-text-field>
        </div>

        <v-subheader class="mx-0 px-0 mb-4 font-weight-bold text-uppercase"
          >{{ $t("formRegisterTitleAccessCredential") }}
          <v-divider class="ml-4"></v-divider>
        </v-subheader>

        <div style="margin: 0 auto; max-width: 400px" class="pr-4">
          <!-- LOGIN -->
          <v-text-field
            v-model="login"
            name="username"
            :label="$t('loginInput')"
            :hint="$t('hinitLogin')"
            :rules="[
              rules.required,
              rules.usernameMax,
              rules.noSpacesAreAllowed,
            ]"
            clearable
            outlined
            @change="checkLogin()"
            :error-messages="errorMessageUser"
            :error="errorActiveUser"
            tabindex="107"
            prepend-icon="mdi-account-plus"
            autocapitalize="off"
          ></v-text-field>

          <!-- PASSWORD -->
          <v-text-field
            :class="[show1 ? 'show-password' : 'hide-password']"
            v-model="password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            type="text"
            :label="$t('password')"
            :rules="[
              rules.required,
              rules.passLength,
              rules.passCaracter,
              rules.max,
            ]"
            @click:append="show1 = !show1"
            required
            clearable
            outlined
            :counter="8"
            maxlength="8"
            prepend-icon="mdi-lock"
            tabindex="109"
            autocapitalize="off"
          ></v-text-field>

          <!-- CONFIRM PASSWORD -->
          <v-text-field
            :class="[show2 ? 'show-password' : 'hide-password']"
            v-model="passwordConfirm"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            type="text"
            :label="$t('confirmPassword')"
            :rules="passMatch"
            @click:append="show2 = !show2"
            required
            :counter="8"
            maxlength="8"
            clearable
            outlined
            prepend-icon="mdi-lock"
            tabindex="110"
            autocapitalize="off"
          ></v-text-field>

          <!-- AGREE TERMS AND PRIVACY -->
          <div class="" v-if="$isCreditOnline()">
            <v-checkbox
              :rules="[rules.required]"
              v-model="userTerms"
              color="green"
              tabindex="112"
            >
              <template v-slot:label>
                <div class="ml-3">
                  {{ $t("certifyIamOfLegalAge") }}
                  <a
                    @click="
                      $router
                        .push({
                          name: 'terms',
                          query: {
                            action: 'post',
                            params: '/player/online/register/operatorDocument',
                          },
                        })
                        .catch((error) => {})
                    "
                    >{{ $t("generalTermsAndConditions") }}</a
                  >
                  {{ $t("and") }}
                  <a
                    @click="
                      $router
                        .push({
                          name: 'privacy',
                          query: {
                            action: 'post',
                            params: 'main/getDocumentDataProtection',
                          },
                        })
                        .catch((error) => {})
                    "
                    >{{ $t("privacy") }}</a
                  >.
                </div>
              </template>
            </v-checkbox>
          </div>

          <!-- CONFIRMA ACOUNT FOR E-MAIL OR SMS -->
          <v-radio-group
            v-model="sendingChannel"
            v-if="!$permissions().registerEmail && !$permissions().registerSMS"
            mandatory
            row
          >
            <div class="mb-2">{{ $t("textRadioConfirmRegister") }}</div>
            <v-radio label="SMS" value="sms"></v-radio>
            <v-radio label="Email" value="email"></v-radio>
          </v-radio-group>

          <!-- Register Recaptcha -->
          <vue-recaptcha
            size="invisible"
            ref="invisibleRecaptcha"
            sitekey="6LeeGAYiAAAAALHUyamQVAlJAMKhEW1v2EPo5Hjx"
            @verify="onVerify"
            @expired="onExpired"
            :loadRecaptchaScript="loadRecaptcha"
          ></vue-recaptcha>

          <!-- ACTIONS! -->
          <v-card-actions class="py-4 mb-10">
            <div
              :class="
                $vuetify.breakpoint.mobile
                  ? 'mr-6 subheading'
                  : 'mr-4 subheading'
              "
              v-if="
                !$permissions().registerEmail && !$permissions().registerSMS
              "
            >
              {{ $t("weSendASMSOrEmail") }}
            </div>
            <div
              v-else-if="$permissions().registerEmail"
              :class="
                $vuetify.breakpoint.mobile
                  ? 'mr-6 subheading'
                  : 'mr-4 subheading'
              "
            >
              {{ $t("weSendAEmail") }}
            </div>
            <div
              v-else-if="$permissions().registerSMS"
              :class="
                $vuetify.breakpoint.mobile
                  ? 'mr-6 subheading'
                  : 'mr-4 subheading'
              "
            >
              {{ $t("weSendASMS") }}
            </div>
            <div class="flex-grow-1"></div>
            <v-btn
              type="submit"
              @click.prevent="handlerRegister"
              id="btn_register_submit"
              color="primary"
              :loading="loading"
              tabindex="111"
              :disabled="
                disabled ||
                  ($isCreditOnline() && !userTerms) ||
                  !valid1 ||
                  !passMatch ||
                  isCheckingForActivePromotion
              "
            >
              {{ $t("register") }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
  <!-- ALERT - Success Register Callback -->

  <v-card class="colorDominant" v-else>
    <v-toolbar height="64" class="elevation-0 flex-grow-0 colorDominant">
      <!-- Mantendo uma cópia do v-btn com o showRegister -->
      <!-- <v-btn
        icon
        @click="(showRegister = false), (vCardForm = true), closeDialog()"
        >
        <v-icon>mdi-close</v-icon>
      </v-btn> -->
      <v-toolbar-title>{{ $t("registrationCompleted") }} </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="(vCardForm = true), closeDialog()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="text-center headline font-weight-light px-6 mt-8">
      <div>
        <v-icon style="font-size: 80px">mdi-email</v-icon>
      </div>

      <div class="font-weight-bold pb-4">{{ msgSuccess }}</div>
      <div>
        <div v-if="smsMsg">
          <h3 class="pb-4 green--text">
            {{ $t("consultYourAccountTextSMS") }}
          </h3>
          <div class="title">
            <span class="pb-4 orange--text">{{ $t("important") }} </span>
            {{ $t("accountVerificationBySMS") }}
          </div>
          <div v-if="emailVerify">
            <div class="mt-8 orange--text">
              <span class="body-2">{{ $t("resendEmailTip") }}</span>
            </div>
          </div>
        </div>
        <div v-else>
          <h3 class="pb-4 green--text">
            {{ $t("consultYourAccountTextEmail") }}
          </h3>

          <div class="title">
            <span class="pb-4 orange--text">{{ $t("important") }} </span>
            {{ $t("accountVerificationByEmail") }}
          </div>

          <div class="mt-8 orange--text">
            <span class="body-2">{{ $t("resendEmailTip") }}</span>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-divider v-if="emailVerify"></v-divider>
    <v-card-actions class="pa-4">
      <div style="width: 100%">
        <div class="text-end">
          <v-btn
            v-if="emailVerify"
            color="primary"
            :block="$vuetify.breakpoint.smAndDown"
            @click="resendEmail"
            :loading="loading"
            :disabled="disableResendConfirmation"
            >{{ btnMsg
            }}<span v-if="count <= 59" class="ml-1 overline">{{ count }}</span>
          </v-btn>
          <!-- <v-spacer></v-spacer> -->
          <!-- <v-btn outlined @click="(vCardForm = true), closeDialog()"
            >{{ $t("close") }}
          </v-btn> -->
        </div>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { validate } from "@/util/form-validate";
import domainsForCaptcha from "@/util/domainsForCaptcha";
import qs from "qs";
import Login from "@/components/login/dialog.vue";
import getInfoTable from "@/util/infoTable";
import axios from "axios";
import VueRecaptcha from "vue-recaptcha";

// Valor inicial do contador resend email
const COUNTER_MAX = 60;
export default {
  props: ["hideCloseDialogProp", "urlRedirect"],
  name: "Register",
  components: {
    Login,
    VueRecaptcha,
  },
  // props: ["urlRedirect"],
  data: () => ({
    cpfValidated: false,
    // emailAndDocumentAccepted: null,
    // showRegister: false,
    show1: false,
    show2: false,
    loading: false,
    valid1: false,

    name: "",
    phone: "",
    email: "",
    cpf: "",
    birthdate: "",

    login: "",
    loginFeedBack: "",
    password: "",
    passwordConfirm: "",
    contract: "",
    terms: false,

    // DESCONTINUADO (ANTIGA DATA DE NASCIMENTO)
    // date: null,
    // menuBirthdate: false,

    userTerms: false,

    // RULES:
    rules: {
      required: validate.required,
      max: validate.max,
      nameValid: validate.nameValid,
      phoneCounter: validate.phoneCounter2,
      passLength: validate.passLength,
      passCaracter: validate.passCaracter,
      validEmail: validate.validEmail,
      usernameMax: validate.usernameMax,
      usernameAz09: validate.usernameAz09,
      docCPF: validate.docCPF,
      validateCPF: validate.validateCPF,
      birthdate: validate.birthdate,
      docMax: validate.docMax,
      invalid: validate.validEmail,
      validateEmailDomain: validate.validateEmailDomain,
      noSpacesAreAllowed: validate.noSpacesAreAllowed,
    },

    // Register Success Callback
    vCardForm: true,
    msgSuccess: "",
    // emailVerify: '',
    loginVerify: "",
    disabled: false,
    disableResendConfirmation: false,

    //When user is indicated from a agent
    agentId: "",

    errorActive: false,
    errorMessage: "",
    // Login
    errorMessageUser: "",
    errorActiveUser: false,
    //Email
    errorMessageEmail: "",
    errorActiveEmail: false,

    endpoint: "",
    maskPhone: null,
    sendingChannel: "sms",
    maybeRequired: true,
    smsMsg: true,
    labelEmail: "",

    placeholderPhone: "",
    domain: "",
    checkPasswordRules: {
      required: true,
    },

    // Loadings
    loadingDoc: false,

    // AFFILIATE Data
    nameAgent: "",
    affiliate_id: "",
    affiliate_progress: true,
    phoneError: false,
    phoneErrorMessage: "",
    validatePhoneLoading: false,
    playerFromAgent: false,
    affiliateCode: "",
    affiliateCodeError: false,
    affiliateCodeErrorMessage: "",

    promoCode: {
      value: "",
      error: {
        status: false,
        message: "",
      },
      success: {
        message: "",
      },
      loading: false,
      checkIntervalId: 0,
    },
    count: COUNTER_MAX,
    resendEmailCounter: null,

    // Recaptcha
    domainsForCaptcha: ["cartola", "betpremier", "pingolbet", "betpix"],
    loadRecaptcha: false,
  }),

  computed: {
    isCheckingForActivePromotion() {
      if (!this.$isCreditOnline()) {
        return false;
      }

      if (this.promoCode.error.status) {
        return false;
      }

      return (
        this.promoCode.value != null &&
        this.promoCode.value != "" &&
        !this.promoCode.success.message
      );
    },
    dialog() {
      return this.$store.state.showDialogRegister;
    },
    hideCloseDialog() {
      if (this.hideCloseDialogProp) {
        return true;
      }

      return false;
    },
    // PHONE RULES - IF TEMPORÁRIO
    // Com regra de negócio apenas para o girosbet (paraguai).
    phoneRule() {
      return this.domain == "girosbet"
        ? validate.phoneCounterMaskPR
        : validate.phoneCounterMaskBR;
    },
    // Repet password
    passMatch() {
      const rules = [];

      let required = this.$t("requiredInput");
      let repeatPassWord = this.$t("repeatThePassword");

      // Required
      if (this.checkPasswordRules.required) {
        const rule = (v) => !!v || required;
        rules.push(rule);
      }

      // Confirm Password
      if (this.passwordConfirm) {
        const rule = (v) => (!!v && v) === this.password || repeatPassWord;
        rules.push(rule);
      }

      return rules;
    },

    // DESCONTINUADO (ANTIGA DATA DE NASCIMENTO)
    // computedDateFormatted() {
    //   return this.$date.format(this.date, "DD-MM-YYYY");
    // },

    url() {
      return this.$store.state.operators.url;
    },
  },
  beforeMount() {
    // Ativando o captcha para os domínios definidos na lista;
    if (domainsForCaptcha.includes(this.$domain())) {
      this.loadRecaptcha = true;
    }
  },
  async mounted() {
    this.playerFromAgent = this.$route.path.includes("player-from-agent");
    this.vCardForm = true;
    this.openDialog = true;

    // DESCONTINUADO (ANTIGA DATA DE NASCIMENTO)
    // this.date = new Date().toISOString().substr(0, 10);

    // Aplicando máscara de telefone;
    let mask = this.$permissions().phoneMask;
    // console.log(mask);
    this.maskPhone = mask;

    // Validação para quando a operação só exclusiva para confirmação via e-mail;
    if (this.$permissions().registerEmail || !this.$isCreditOnline()) {
      this.maybeRequired = this.rules.required;
      this.sendingChannel = this.$permissions().registerEmail ? "email" : "sms";
      this.labelEmail = "E-mail";
    } else if (this.$permissions().registerSMS) {
      // Esse else if foi adicionado para o tratamento quando for sem e-mail e sem confirmação pelo e-mail
      this.maybeRequired = this.rules.required;
      this.sendingChannel = "sms";
      // this.labelEmail = this.$t("optionalEmail");
    } else {
      this.labelEmail = this.$t("optionalEmail");
    }

    this.agentId = localStorage.getItem("agentId");

    // Placeholder Phone
    this.domain = this.$domain();
    // IF TEMPORÁRIO (para tratamento de mask PR e BR);
    this.placeholderPhone =
      this.domain == "girosbet" ? "000 00-0000" : "(00) 90000-0000";

    // CONDIÇÕES PARA "PLAYER FROM AGENT" *** AFFILIATE ***
    if (this.playerFromAgent) {
      getInfoTable(true);
      this.agentId = this.$route.params.affiliate_id;
      // Armazenando o Código do Agent/AFFILIATE no LocalStorage
      localStorage.setItem("agentId", this.agentId);
      const response = await this.$axios.post(
        "/player/online/register/getNameAgent",
        this.$formdata({ agentId: this.agentId, domain: this.$domain() })
      );
      this.affiliate_progress = false;
      this.nameAgent = response.data.dados;

      // Fetch promotion code
      this.$axios
        .post(
          "/player/online/register/getCodeByAffiliate",
          this.$formdata({
            affiliate_code: this.agentId,
            domain: this.$domain(),
          })
        )
        .then((res) => {
          if (
            res.data.dados.codigo &&
            res.data.dados.codigo != null &&
            res.data.dados.codigo != ""
          ) {
            this.promoCode.value = res.data.dados.codigo;
          }
        });
    }

    if (this.$store.state.currentRegisterPromotionCode) {
      this.promoCode.value = this.$store.state.currentRegisterPromotionCode;
      this.$store.commit("resetCurrentRegisterPromotionCode");
    }
  },
  watch: {
    "promoCode.value"(val) {
      if (val == null || val == "") {
        this.promoCode.error.status = false;
        this.promoCode.success.message = "";
        this.promoCode.error.message = "";
        return;
      }
      this.debouncedUserHasPromotion();
    },
    dialog(val) {
      if (val) {
        if (this.$store.state.currentRegisterPromotionCode) {
          this.promoCode.value = this.$store.state.currentRegisterPromotionCode;
          this.$store.commit("resetCurrentRegisterPromotionCode");
        }
      } else {
        this.promoCode.value = "";
        this.promoCode.error.status = false;
        this.promoCode.error.message = "";
        this.promoCode.success.message = "";
        clearInterval(this.resendEmailCounter);
        this.count = COUNTER_MAX;
      }
    },
    affiliateCode() {
      this.affiliateCodeErrorMessage = "";
      this.affiliateCodeError = false;
    },
    login() {
      this.errorMessageUser = "";
      this.errorActiveUser = false;
    },
    email(val) {
      if (val == null) {
        this.email = "";
      }
      this.errorMessageEmail = "";
      this.errorActiveEmail = false;

      // Se o usuário tentar usar um email já cadastrado
      // e resolver apagar o email e receber a confirmação por sms
      // essa condicional limpa o input do email e permite
      // seguir com o cadastro
      if (this.sendingChannel !== "email" && val == false) {
        this.disabled = false;
      }
    },
    cpf() {
      this.errorMessage = "";
      this.errorActive = false;
    },

    // DESCONTINUADO (ANTIGA DATA DE NASCIMENTO)
    // menu(val) {
    //   val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    // },

    sendingChannel(val) {
      if (val == "email") {
        this.maybeRequired = this.rules.required;
      } else if (val == "sms" && !this.$isCreditOnline()) {
        this.maybeRequired = this.rules.required;
      } else {
        this.maybeRequired = true;
      }

      // Se o usuário tentar usar um email já cadastrado
      // e resolver apagar o email e receber a confirmação por sms
      // essa condicional limpa o input do email e permite
      // seguir com o cadastro
      if (val != "email" && this.email == false) {
        this.disabled = false;
      }
    },
    disableResendConfirmation(val) {
      // console.log(val);
      if (val && this.count > 1) {
        this.resendEmailCounter = setInterval(this.counter, 1000);
      } else {
        clearInterval(this.resendEmailCounter);
      }
    },
  },
  methods: {
    registerSuccessRedirect() {
      // page/register
      if (this.$route.name === "Register") {
        this.$router.push({ name: "RegisterSuccessPage" });
        // player-from-agent
      } else if (this.playerFromAgent) {
        this.$router.push({ name: "RegisterSuccessFromAgent" });
      }
      // global register dialog
      else {
        const hasBt = this.$permissions().bigTable;
        const suffix = hasBt ? "Bt" : "Sports";
        this.$router.push({ name: `RegisterSuccess${suffix}` });
      }
    },

    // Registrando Evento no Google Analytics
    // De início de cadastro;
    startRegistrationGA4(name) {
      let start = sessionStorage.getItem("start_registration");
      if (!start) {
        this.$gtag.start_registration(name);
        sessionStorage.setItem("start_registration", true);
        return;
      }
    },

    // Validação do backend do recaptcha.
    onVerify: function(response) {
      const headers = {
        "Content-Type": "application/json",
      };
      const endpoint =
        "https://0m5iy0epbc.execute-api.us-east-2.amazonaws.com/recaptcha";
      axios
        .post(endpoint, { token: response }, { headers: headers })
        .then((resp) => {
          const data = resp.data;
          if (data.success) {
            this.doRegister();
          } else {
            this.disabled = false;
            const msg = "Error de validação!";
            const color = "warning";
            this.$store.commit("setNotification", {
              msg,
              color,
            });
          }
        })
        .finally(() => this.$refs.invisibleRecaptcha.reset());
    },

    onExpired: function() {
      console.log("Expired");
    },

    debouncedUserHasPromotion() {
      clearInterval(this.promoCode.checkIntervalId);

      this.promoCode.checkIntervalId = setTimeout(() => {
        this.userHasPromotion();
      }, 1000);
    },

    userHasPromotion() {
      this.promoCode.loading = true;

      if (this.promoCode.value == null || this.promoCode.value == "") {
        return;
      }

      this.$axios
        .post(
          "/player/bonus/promotion/registerPromotionActive",
          this.$formdata({
            code_promo: this.promoCode.value,
            domain: this.$domain(),
          })
        )
        .then((res) => {
          this.promoCode.error.status = false;
          this.promoCode.error.message = "";
          this.promoCode.success.message = res.data.messages;
        })
        .catch((err) => {
          this.promoCode.error.status = true;
          this.promoCode.error.message = err.response.data.messages.error;
        })
        .finally(() => {
          this.promoCode.loading = false;
        });
    },

    validatePhone() {
      const phone = this.phone.replace(
        /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
        ""
      );

      if (phone.length != 11) {
        return;
      }

      this.validatePhoneLoading = true;

      const body = { phone, domain: this.$domain() };
      this.$axios
        .post("/player/online/register/validatePhone", this.$formdata(body))
        .then(() => {
          this.phoneError = false;
          this.phoneErrorMessage = "";
          this.disabled = false;
          this.$refs.form.resetValidation();
        })
        .catch((err) => {
          this.phoneError = true;
          this.phoneErrorMessage = err.response.data.messages.error;
        })
        .finally(() => {
          this.validatePhoneLoading = false;
        });
    },
    // DESCONTINUADO (ANTIGA DATA DE NASCIMENTO)
    // save(date) {
    //   this.$refs.menu.save(date);
    // },

    // formatDate(date) {
    //   if (!date) return null;
    //   const [year, month, day] = date.split("-");
    //   return `${day}/${month}/${year}`;
    // },
    checkCPF() {
      const cpf = this.cpf.replace(/[\s.-]*/gim, "");
      if (cpf.length == 11) {
        const data = {
          domain: this.$domain(),
          cpf: cpf,
        };
        this.loadingDoc = true;
        this.$axios
          .post("/player/online/register/fetchCpf", this.$formdata(data))
          .then(() => {
            this.cpfValidated = true;
            return;
          })
          .catch((error) => {
            this.cpfValidated = false;
            this.errorMessage = "CPF já cadastrado!";
            this.errorActive = true;
            // this.NotificationErrorDefault(error);
            const msg = error.response.data.messages[0];
            const color = "warning";
            this.$store.commit("setNotification", {
              msg,
              color,
            });
          })
          .finally(() => (this.loadingDoc = false));
      } else {
        this.cpfValidated = false;
        return;
      }
    },

    // suggestionLogin(phone) {
    //   // eslint-disable-next-line no-useless-escape
    //   this.login = phone.replace(
    //     /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
    //     ""
    //   );
    // },

    // Check Email
    checkEmail(email) {
      this.disabled = true;
      return new Promise((resolve, reject) => {
        const endpoint = this.$isCreditOnline()
          ? "player/register/fetchEmailWithDocument"
          : "player/register/fetchEmail";
        this.$axios
          .post(
            endpoint,
            this.$formdata({
              email,
              document: this.cpf.replace(/[\s.-]*/gim, ""),
              domain: this.$domain(),
            })
          )
          .then((resp) => {
            this.disabled = false;
            // if (this.$isCreditOnline()) {
            //   this.emailAndDocumentAccepted = true;
            // }
            resolve(resp);
          })
          .catch((error) => {
            this.errorMessageEmail = this.$t("emailAlreadyRegistered");
            this.errorActiveEmail = true;
            // if (this.$isCreditOnline()) {
            //   this.emailAndDocumentAccepted = false;
            // }
            reject(error);
          });
      });
    },

    // Check Login
    checkLogin() {
      this.$axios
        .post(
          "player/register/fetchLogin",
          this.$formdata({
            login: this.login,
            domain: this.$domain(),
          })
        )
        .catch(() => {
          this.errorMessageUser = this.$t("loginAlreadyRegistered");
          this.errorActiveUser = true;
          // this.NotificationErrorDefault(error);
          // const msg = error.response.data.messages.error;
          // const color = "warning";
          // this.$store.commit("setNotification", {
          //   msg,
          //   color,
          // });
        });
    },

    // limpa o formulário
    cancelForms() {
      // this.showRegister = false;
      this.userTerms = false;
      this.$refs.form.reset();
    },

    // VALIDATE E-MAIL
    validateEmail() {
      if (!this.cpfValidated && this.$isCreditOnline()) {
        return;
      }
      const email = this.email;
      if (!email) return;
      // se for vazio pode avnançar
      if (email == false) {
        this.disabled = false;
        this.$refs.form.resetValidation();
      }

      if (email.length > 0) {
        this.loading = true;
        this.disabled = false;
        this.checkEmail(email)
          .then((resp) => {
            if (resp.status === 200) {
              // E-mail válido
            }
          })
          .catch(() => {
            // E-mail ja cadastrado no sistema
            this.disabled = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    // VALIDATE LOGIN
    validateLogin(login) {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.checkLogin(login)
          .then((resp) => {
            if (resp.status === 200) {
              this.e1 = 4;
            }
          })
          .catch(() => {
            // console.log(err.resp);
            this.valid3 = false;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        return false;
      }
    },

    handlerRegister() {
      if (this.$refs.form.validate()) {
        if (this.loadRecaptcha) {
          this.disabled = true;
          // Ao executar o recptcha ele retorna um token e chama a função de callback "onVerify"
          // que faz a validação no backend.
          this.$refs.invisibleRecaptcha.execute();
        } else {
          // 3. Cadastro normal sem captcha
          this.doRegister();
        }
      } else {
        const msg = this.$t("errorOnForm");
        const color = "warning";
        this.$store.commit("setNotification", {
          msg,
          color,
        });
        this.$Progress.fail();
      }
    },

    doRegister() {
      this.disabled = true;
      this.disableResendConfirmation = false;
      this.loading = true;

      // Format Birthdate American
      var formatBirthdate = this.birthdate.split("-");
      formatBirthdate = `${formatBirthdate[2]}-${formatBirthdate[1]}-${formatBirthdate[0]}`;

      const data = {
        domain: this.$domain(),
        nome: this.name.trim(),
        email: this.email ? this.email.toLowerCase() : "",
        // Items apenas para o Operador Online (Credit 2)
        cpf: this.cpf.replace(/[\s.-]*/gim, ""),
        birthDate: this.$isCreditOnline() ? formatBirthdate : "",
        acceptedTerms: this.userTerms == true ? 1 : 0,
        // tira a mascara
        // eslint-disable-next-line no-useless-escape
        celular: this.phone.replace(
          /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
          ""
        ),
        login: this.login,
        password: this.password,
        url_client: `${window.location.protocol}//${window.location.hostname}/`,
        sending_channel: this.$permissions().registerEmail
          ? "email"
          : this.sendingChannel,
        affiliate_code: this.affiliateCode,
        agentId: this.agentId,
        promotion_code: this.promoCode.value,
      };

      this.register(data)
        .then((resp) => {
          this.vCardForm = false;
          this.emailVerify = data.email === "" ? false : data.email;
          // this.emailVerify = false;
          this.loginVerify = data.login;
          const msg = resp.data.messages;
          var idUser = resp.data.dados.id_user;
          this.$store.commit("setNotification", {
            msg,
            color: "green",
          });
          this.$refs.form.reset();

          if (data.sending_channel == "sms") {
            this.smsMsg = true;
          }
          if (data.sending_channel == "sms" && this.emailVerify == data.email) {
            this.btnMsg = this.$t("confirmByEmail");
            this.smsMsg = true;
          }
          if (data.sending_channel == "email") {
            this.btnMsg = this.$t("resendEmail");
            this.smsMsg = false;
            // this.nextStep = true;
            this.disableResendConfirmation = true;
          }

          return idUser;
        })
        .then(async (idUser) => {
          // Integrations
          // Rd Station
          this.$rdStation("createUser", data, idUser);
          // Active Campaign
          this.$activeCampaign("createContact", data, idUser);
          // Webhook
          this.$webhook("sendMessage", data);
          // Zendesk
          this.$zendesk("createUser", data, idUser);
        })
        .catch((err) => {
          if (
            err.response.data.dados &&
            err.response.data.dados.affiliate_not_found
          ) {
            this.affiliateCodeError = true;
            this.affiliateCodeErrorMessage = err.response.data.messages;
          } else {
            this.NotificationErrorDefault(err);
          }
        })
        .finally(() => {
          this.loading = false;
          this.disabled = false;
          this.promoCode.success.message = "";
        });
    },

    // Register API
    register(data) {
      return new Promise((resolve, reject) => {
        this.endpoint = this.$isCreditOnline()
          ? "/player/online/register/addPlayer"
          : "/player/register/addPlayer";
        this.$axios
          .put(this.endpoint, qs.stringify(data))
          .then((resp) => {
            this.userTerms = false;

            // Register Event Google Analytics
            var method = this.sendingChannel === "sms" ? "sms" : "email";
            var id_user = resp.data.dados.id_user;
            this.$gtag.pre_sign_up(method, id_user, data);

            resolve(resp);
          })
          .catch((error) => {
            this.disabled = false;
            reject(error);
          });
      });
    },

    // Create User
    // Foi divido em handleRegister (Onde é feita as validações do form e verificação
    // se o cliente tem o recaptcha, verifica com o back se está ok o cadastro e
    // segue para o Cadastro)
    // E em doRegister (toda a lógica do createUser)

    // createUser() {
    //   if (this.$refs.form.validate()) {
    //     this.disabled = true;
    //     this.disableResendConfirmation = false;
    //     this.loading = true;

    //     // Format Birthdate American
    //     var formatBirthdate = this.birthdate.split("-");
    //     formatBirthdate = `${formatBirthdate[2]}-${formatBirthdate[1]}-${formatBirthdate[0]}`;

    //     const data = {
    //       domain: this.$domain(),
    //       nome: this.name,
    //       email: this.email ? this.email.toLowerCase() : "",
    //       // Items apenas para o Operador Online (Credit 2)
    //       cpf: this.cpf.replace(/[\s.-]*/gim, ""),
    //       birthDate: this.$isCreditOnline() ? formatBirthdate : "",
    //       acceptedTerms: this.userTerms == true ? 1 : 0,
    //       // tira a mascara
    //       // eslint-disable-next-line no-useless-escape
    //       celular: this.phone.replace(
    //         /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
    //         ""
    //       ),
    //       login: this.login,
    //       password: this.password,
    //       url_client: `${window.location.protocol}//${window.location.hostname}/`,
    //       sending_channel: this.$permissions().registerEmail
    //         ? "email"
    //         : this.sendingChannel,
    //       affiliate_code: this.affiliateCode,
    //       agentId: this.agentId,
    //       promotion_code: this.promoCode.value,
    //     };

    //     this.register(data)
    //       .then((resp) => {
    //         this.vCardForm = false;
    //         this.emailVerify = data.email === "" ? false : data.email;
    //         this.loginVerify = data.login;
    //         const msg = resp.data.messages;
    //         var idUser = resp.data.dados.id_user;
    //         this.$store.commit("setNotification", {
    //           msg,
    //           color: "green",
    //         });
    //         this.$refs.form.reset();

    //         if (data.sending_channel == "sms") {
    //           this.smsMsg = true;
    //         }
    //         if (
    //           data.sending_channel == "sms" &&
    //           this.emailVerify == data.email
    //         ) {
    //           this.btnMsg = this.$t("confirmByEmail");
    //           this.smsMsg = true;
    //         }
    //         if (data.sending_channel == "email") {
    //           this.btnMsg = this.$t("resendEmail");
    //           this.smsMsg = false;
    //           // this.nextStep = true;
    //           this.disableResendConfirmation = true;
    //         }

    //         return idUser;
    //       })
    //       .then(async (idUser) => {
    //         // Integrations - Active Campaign
    //         this.$integrations.activeCampaign("createContact", data, idUser);
    //       })
    //       .catch((err) => {
    //         if (
    //           err.response.data.dados &&
    //           err.response.data.dados.affiliate_not_found
    //         ) {
    //           this.affiliateCodeError = true;
    //           this.affiliateCodeErrorMessage = err.response.data.messages;
    //         } else {
    //           this.NotificationErrorDefault(err);
    //         }
    //       })
    //       .finally(() => {
    //         this.loading = false;
    //         this.disabled = false;
    //         this.promoCode.success.message = "";
    //       });
    //   } else {
    //     const msg = this.$t("errorOnForm");
    //     const color = "warning";
    //     this.$store.commit("setNotification", {
    //       msg,
    //       color,
    //     });
    //     this.$Progress.fail();
    //   }
    // },

    // reenvia o email de confirmação
    resendEmail() {
      this.loading = true;
      this.disableResendConfirmation = true;
      const data = {
        domain: this.$domain(),
        email: this.emailVerify,
        login: this.loginVerify,
        url_client: `${window.location.protocol}//${window.location.hostname}/`,
      };
      this.$axios
        .post("player/register/resendEmail", this.$formdata(data))
        .then((resp) => {
          const msg = resp.data.messages;
          const color = "success";
          this.$store.commit("setNotification", {
            msg,
            color,
          });
          if (this.btnMsg == this.$t("confirmByEmail")) {
            this.btnMsg = this.$t("resendEmail");
          }
        })
        .catch(this.NotificationErrorDefault)
        // then?
        .finally(
          () => (this.loading = false) //,(this.countDownTimer())
        );
    },

    // Notification Error Default
    NotificationErrorDefault(error) {
      const msg = error.response.data.messages.error;
      const color = "warning";
      this.$store.commit("setNotification", {
        msg,
        color,
      });
      this.disableResendConfirmation = false;
    },

    closeDialog() {
      this.$store.commit("showDialogRegister", false);
    },
    // contador do resend email
    counter() {
      if (this.count == 1) {
        clearInterval(this.resendEmailCounter);
        this.disableResendConfirmation = false;
        this.count = COUNTER_MAX;
      } else {
        this.count -= 1;
      }
    },
    onKeyUp() {
      this.promoCode.value = this.promoCode.value
        .toUpperCase()
        // Tira espaço em branco
        .replace(/\s/g, "");
    },
  },
};
</script>
